import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TabuRequestApi, TabuRequestUtils } from "@10x/tabu-mobile-api";
import { getParticipantID } from "@10x/sso";
import { HistoryProcedure, HistoryResponse, ProcedureIDs } from "@10x/tabu-mobile-api/dist/requests/entity";
import { getTabuRequestStatus, getTabuRequestStatusClass } from "@my-dld/utils/ProcedureUtils";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { navigate } from "@my-dld/utils/StoreUtils";
import { DateUtil, LocaleUtil } from "@eres/core";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import TabuRequestsListView from "@my-dld/components/MyRequest/TabuRequestsListView";
import { getPropertyType } from "@my-dld/utils/PropertyUtils";
import TabuRequestsGridView from "@my-dld/components/MyRequest/TabuRequestsGridView";
import { formatAppDate } from "@my-dld/utils/Utils";
import { MyRequestsBCItem } from "@my-dld/contexts/PageContext";

interface Props extends RoutedViewProps<{ procedureId: string }> {

}

interface State {
	isLoading: boolean;
	procedureId: string;
	tabuRequests: HistoryProcedure[];
}

class TabuRequests extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isLoading: true,
			procedureId: props.match.params.procedureId,
			tabuRequests: [],
		};
	}

	private static getTitle( procedureId: string ) {
		const tabuServiceById = TabuRequestUtils.getTabuServiceById( procedureId );
		if ( tabuServiceById ) return LocaleUtil.getLocalValue( tabuServiceById.Name );
		switch ( procedureId ) {
			case "" + ProcedureIDs.TO_WHOM_CONCERN:
				return Strings.to_whom_it_may_concern;

			case "" + ProcedureIDs.LOSS_CERTIFICATE:
				return Strings.loss_certificate;

			case "" + ProcedureIDs.SITE_PLAN:
				return Strings.site_plan;

			case "" + ProcedureIDs.PROPERTY_VALUATION:
				return Strings.valuation_certificate;

			case "" + ProcedureIDs.INTERNAL_PROPERTY_VALUATION:
				return Strings.internal_property_valuation;

			case "" + ProcedureIDs.PROPERTY_DETAIL_CERT:
				return Strings.property_detail_certificate;
			case "" + ProcedureIDs.BCS_RE_CLASSIFICATION:
				return Strings.bcs_reclassification;
			default:
				return "";
		}
	}

	componentDidMount() {
		this.loadTabuRequests();
	}

	render() {
		const { isLoading, tabuRequests, procedureId } = this.state;
		const title = TabuRequests.getTitle( procedureId );
		return <ListGridDataView
			bcItems={ [ MyRequestsBCItem ] }
			isLoading={ isLoading }
			dataAvailable={ tabuRequests.length > 0 }
			title={ title }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }/>;
	}

	private renderListView = () => {
		const { procedureId, tabuRequests } = this.state;
		return <TabuRequestsListView
			procedureId={ procedureId }
			items={ tabuRequests }
			onDetails={ this.navigateDetails }/>;
	};

	private renderGridView = () => {
		const { procedureId, tabuRequests } = this.state;
		return <TabuRequestsGridView
			procedureId={ procedureId }
			items={ tabuRequests }
			onDetails={ this.navigateDetails }/>;
	};

	private loadTabuRequests() {
		const { procedureId } = this.state;
		TabuRequestApi.getRequests( "" + getParticipantID(), procedureId ).then( ( resp: HistoryResponse ) => {
			const requests: HistoryProcedure[] = resp.Response ? resp.Response : [];
			this.setState( {
				isLoading: false,
				tabuRequests: requests,
			} );
		} ).catch( reason => {
			this.setState( { isLoading: false } );
			showErrorMessage( reason );
		} );
	}

	private navigateDetails = ( historyProcedure: HistoryProcedure ) => {
		navigate( `/mydld/my_requests/tabu/${ historyProcedure.ProcedureId }/${ historyProcedure.ProcedureNumber }/${ historyProcedure.ProcedureYear }`, undefined, {
			procedure: historyProcedure
		} );
	};
}

export function getTabuReqPropertyType( item: HistoryProcedure ) {
	return getPropertyType( item.PropertyTypeId );
}

export function getTabuReqStatus( item: HistoryProcedure ) {
	return getTabuRequestStatus( item.RequestStatusId );
}

export function getTabuReqStatusClass( item: HistoryProcedure ) {
	return getTabuRequestStatusClass( item.RequestStatusId );
}

export function getTabuReqTransactionNo( item: HistoryProcedure ) {
	return item.ProcedureNumber + "/" + item.ProcedureYear;
}

export function getTabuReqDate( item: HistoryProcedure ) {
	const date = DateUtil.parseDate( item.RequestDate, "YYYY-MM-DDThh:mm:ss" );
	return formatAppDate( date, "en" );
}

export function getTabuReqDateTimeStamp( item: HistoryProcedure ) {
	const date = DateUtil.parseDate( item.RequestDate, "YYYY-MM-DDThh:mm:ss" );
	return date?.getTime?.() ?? 1;
}

export function getTabuReqVoucherNo( item: HistoryProcedure ) {
	return item.VoucherNumber ? item.VoucherNumber + "" : "-";
}

export default TabuRequests;
